"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

exports.__esModule = true;
exports.mt940 = exports.mt940parser = exports.mt940matcher = exports.generateYnabDate = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var read_to_buffer_1 = require("../../util/read-to-buffer");

exports.generateYnabDate = function (input) {
  var match = input.match(/(\d{4})-(\d{2})-(\d{2})/);

  if (!match) {
    throw new Error('The input is not a valid date. Expected format: YYYY-MM-DD');
  }

  var year = match[1],
      month = match[2],
      day = match[3];
  return [month.padStart(2, '0'), day.padStart(2, '0'), year].join('/');
};

exports.mt940matcher = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var mt, buffer, res, _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return __importStar(require('mt940-js'));
          })];

        case 1:
          mt = _b.sent();
          return [4
          /*yield*/
          , read_to_buffer_1.readToBuffer(file)];

        case 2:
          buffer = _b.sent();
          _b.label = 3;

        case 3:
          _b.trys.push([3, 5,, 6]);

          return [4
          /*yield*/
          , mt.read(buffer)];

        case 4:
          res = _b.sent();
          return [2
          /*return*/
          , res.length > 0];

        case 5:
          _a = _b.sent();
          return [3
          /*break*/
          , 6];

        case 6:
          return [2
          /*return*/
          , false];
      }
    });
  });
};

exports.mt940parser = function (file) {
  return __awaiter(void 0, void 0, void 0, function () {
    var mt, buffer, statements;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , Promise.resolve().then(function () {
            return __importStar(require('mt940-js'));
          })];

        case 1:
          mt = _a.sent();
          return [4
          /*yield*/
          , read_to_buffer_1.readToBuffer(file)];

        case 2:
          buffer = _a.sent();
          return [4
          /*yield*/
          , mt.read(buffer)];

        case 3:
          statements = _a.sent();
          return [2
          /*return*/
          , statements.map(function (s) {
            return {
              accountName: [s.referenceNumber, s.accountId].filter(Boolean).join(' '),
              data: s.transactions.map(function (t) {
                return {
                  Inflow: t.isCredit ? t.amount : undefined,
                  Outflow: t.isCredit ? undefined : t.amount,
                  Date: exports.generateYnabDate(t.entryDate),
                  Memo: t.description
                };
              })
            };
          })];
      }
    });
  });
};

exports.mt940 = {
  name: 'MT940 (standard)',
  link: 'https://en.wikipedia.org/wiki/MT940',
  country: 'international',
  fileExtension: 'sta',
  filenamePattern: /(.*)\.sta$/,
  match: exports.mt940matcher,
  parse: exports.mt940parser
};